'use client';

import { ReactNode } from 'react';

import { AdminSidebar } from '@components/Admin/components/AdminSidebar';
import { MainContent } from '@components/Admin/components/styles';
import { AdminPageContainer } from '@components/Common';

interface AdminLayoutProps {
  children: ReactNode;
}

export const AdminLayout = ({ children }: AdminLayoutProps) => {
  return (
    <AdminPageContainer>
      <MainContent>
        <AdminSidebar />
        {children}
      </MainContent>
    </AdminPageContainer>
  );
};
